(function() {
  'use strict';

  var shippingDataPromise = null;

  function getShippingData() {
    if (shippingDataPromise) return shippingDataPromise;

    var shopDomain = window._21eShopDomain
      || (window.Shopify && window.Shopify.shop)
      || window.location.hostname;

    var apiUrl = 'https://toolbox-api.21energy.io/api/shipping-settings?shop=' + shopDomain;

    shippingDataPromise = fetch(apiUrl, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function(response) {
        if (!response.ok) throw new Error('API error ' + response.status);
        return response.json();
      })
      .then(function(json) {
        if (json && json.success && json.data) return json.data;
        throw new Error('Invalid API response');
      })
      .catch(function(err) {
        console.warn('[product-card-shipping] API failed, using fallback:', err.message);
        shippingDataPromise = null;
        return window._21eShippingFallback || null;
      });

    return shippingDataPromise;
  }

  function populateCards(shippingData) {
    if (!shippingData || !shippingData.shipping_zones) return;

    var countryDetection = detectCustomerCountry();
    var customerCountry = countryDetection.customerCountry;

    var zone = findBestShippingZone(shippingData.shipping_zones, customerCountry);
    if (!zone) return;

    var moneyFormat = window.shopifyMoneyFormat
      || (window.Shopify && window.Shopify.money_format)
      || '{{amount}} EUR';
    var currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var currencySymbol = window.shopifyCurrencySymbol || currencyCode;

    var freeText = window._21eProductCardTranslations
      ? window._21eProductCardTranslations.free
      : 'Free shipping';
    var labelText = window._21eProductCardTranslations
      ? window._21eProductCardTranslations.label
      : 'Shipping';

    var cards = document.querySelectorAll('.card__shipping-cost');

    cards.forEach(function(card) {
      var textEl = card.querySelector('.card__shipping-cost-text');
      if (!textEl) return;

      var productPrice = parseInt(card.dataset.productPrice, 10) || 0;
      var productWeight = parseFloat(card.dataset.productWeight) || 0;

      var result = calculateShippingCost(zone, productPrice, productWeight, currencyCode);

      if (result.free_shipping || result.threshold_met) {
        textEl.textContent = freeText;
        card.classList.add('card__shipping-cost--free');
      } else if (result.cost > 0) {
        var formatted = formatShippingCost(card, result.cost, moneyFormat, currencySymbol, currencyCode);
        textEl.textContent = labelText + ': ' + formatted;
      } else {
        textEl.textContent = freeText;
        card.classList.add('card__shipping-cost--free');
      }
    });
  }

  function init() {
    var cards = document.querySelectorAll('.card__shipping-cost');
    if (cards.length === 0) return;

    getShippingData().then(function(data) {
      if (data) populateCards(data);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window._21eProductCardShipping = { init: init };
})();
